import * as Actions from '../actions';
import * as moment from 'moment';

const initialState = {
    course: {
        company_calendar_course_id: 0,
        course_id: 0,
        StartDate: '',
        EndDate: '',
        Unscheduled: 0,
        CourseName: '',
        Color: '#DDDDDD',
        Instructors: [
            { FullName: 'No Instructor' }
        ],
        Assets: [],
        Notifications: [],
        nextSelfPacedEvent: [{
            company_calendar_event_id: 0,
            EventType: 'none'
        }]
    },
    courseSchedule: [],
    events: [],
    gradebook: {
        eventList: [],
        recentGradedEvents: [],
        outstandingEvents: []
    },
    loaded: false
};


const courseReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_COURSE_INFO):
            {
                return {
                    ...state,
                    course: {
                        ...state.course,
                        ...action.payload
                    }
                }
            }
        case (Actions.GET_COURSE_EVENTS):
            {
                return {
                    ...state,
                    events: action.payload.map(e => {
                        return {
                            ...e,
                            start: new Date(e.StartTime),
                            end: new Date(e.EndTime),
                            title: e.EventName,
                            Unscheduled: moment(e.StartTime).format('H') === '0' && moment(e.EndTime).format('H') === '0' ? 1 : 0
                        }
                    }),
                    // nextSelfPacedEvent: selfPace
                }
            }

        case (Actions.GET_COURSE_GRADEBOOK):
            {
                return {
                    ...state,
                    gradebook: {
                        ...action.payload,
                        recentGradedEvents: action.payload.event_list,
                        outstandingEvents: action.payload.event_list.filter(e => e.EventStatus === 'Past Due' || e.EventStatus === 'Retake Event')
                    }

                }
            }

        case (Actions.GET_COURSE_ASSETS):
            {
                return {
                    ...state,
                    course: {
                        ...state.course,
                        Assets: action.payload
                    }

                }
            }

        case (Actions.GET_COURSE_NOTIFICATIONS):
            {
                return {
                    ...state,
                    course: {
                        ...state.course,
                        Notifications: action.payload
                    }
                }
            }

        case (Actions.UPDATE_PAGE_LOADED):
            {
                return {
                    ...state,
                    loaded: action.payload
                }
            }
        case (Actions.SELF_PACED_GET_NEXT_EVENT):
            {
                return {
                    ...state,
                    course: {
                        ...state.course,
                        nextSelfPacedEvent: action.payload
                    }
                }
            }
        case (Actions.REMOVE_RESOLVED_NOTIFICATION):
            {
                return {
                    ...state,
                    course: {
                        ...state.course,
                        Notifications: state.course.Notifications.filter(n => n.notification_relation_id != action.payload)
                    }
                }
            }
        case (Actions.RESET_COURSE_DASHBOARD):
            {
                return {
                    ...initialState
                }
            }
        default:
            {
                return state;
            }
    }
}

export default courseReducer;


// WEBPACK FOOTER //
// src/main/content/dashboard/store/reducers/course.reducer.js